import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ENVIRONMENT } from '@libs/shared/model/environment.token';
import { HttpAuthInterceptorService } from '@libs/utils/src';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { RequestInterceptorService } from '@libs/request-interceptor/request-interceptor';

@NgModule({
	exports: [AppRoutingModule],
	imports: [HttpClientModule, AppRoutingModule],
	providers: [
		{ provide: ENVIRONMENT, useValue: environment },
		//  line 15-19, comment just to work locally
 		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpAuthInterceptorService,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestInterceptorService,
			multi: true
		}
	]
})
export class CoreModule { }
